import LoadingIndicator from 'components/ReusableComponents/LoadingIndicator'
import { BENames } from 'main/hotelBrandsAndChains'
import moment from 'moment'
import { useState } from 'react'
import { useHistory } from 'react-router-dom'
import { useToasts } from 'react-toast-notifications'
import { windowPopup } from 'window-popup'

import Box from '../Box'
import styles from '../Hotel.module.scss'

const BookingEngineBox = ({
  bookingEngine,
  id,
  lastAutomatedInfoSyncOn,
  subsidiaryId,
  externalHotelId
}) => {
  const history = useHistory()
  const { addToast } = useToasts()

  const [isLoading, setIsLoading] = useState(false)
  const checkInDate = moment().format('YYYY-MM-DD')
  const checkOutDate = moment().add(1, 'day').format('YYYY-MM-DD')

  const generateBookingEngineLink = async () => {
    setIsLoading(true)
    try {
      const response = await fetch(
        `https://api-core.directful.com/api/bookingengine/link?SubsidiaryId=${subsidiaryId}&CheckIn=${moment(
          checkInDate
        ).format('YYYY-MM-DD')}&CheckOut=${moment(checkOutDate).format('YYYY-MM-DD')}`
      )
      const res = await response.json()
      if (!res.isSuccess) throw new Error(res.message)
      return res.result.url
    } catch (error) {
      addToast(`Couldn't get booking engine link`, {
        appearance: 'error',
        autoDismiss: true
      })
      return null
    } finally {
      setIsLoading(false)
    }
  }

  const handleCornerButtonClick = async () => {
    if (bookingEngine) {
      const url = await generateBookingEngineLink()
      if (url && !isLoading) {
        windowPopup(375, 640, url, 'Dashboard')
      }
    } else {
      history.push(`/editHotel/${id}/${lastAutomatedInfoSyncOn ? 'limited' : ''}`)
    }
  }

  return (
    <Box
      title="Booking Engine"
      hasCornerButton
      cornerButtonText={bookingEngine ? 'Test URL' : 'Edit'}
      onClickCornerButton={handleCornerButtonClick}
    >
      <div className={styles.boxRowHolder}>
        {isLoading ? (
          <div className={styles.bookingEngineContainer}>
            <LoadingIndicator />
          </div>
        ) : (
          <div className={styles.bookingEngineContainer}>
            <div
              className={bookingEngine ? styles.bookingEngineName : styles.infoNotFound}
            >
              {bookingEngine ? BENames[bookingEngine] : 'Unknown'}
            </div>
            <div className={styles.bookingEngineId}>
              {externalHotelId ? externalHotelId : 'Hotel id is not set'}
            </div>
          </div>
        )}
      </div>
    </Box>
  )
}

export default BookingEngineBox
